/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForSaasUserManaged extends models.StorageConfigurationBaseForSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForSaasUserManaged");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForSaasUserManaged.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForSaasUserManaged>): StorageConfigurationForSaasUserManaged {
        let obj = Object.assign(new StorageConfigurationForSaasUserManaged(), model);
        StorageConfigurationForSaasUserManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForSaasUserManaged>): StorageConfigurationForSaasUserManaged {
        if (!model) return null;
        return StorageConfigurationForSaasUserManaged.newInstance(<StorageConfigurationForSaasUserManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForSaasUserManaged) {
        if (!obj) return;

        models.StorageConfigurationForSaasUserManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForSaasUserManaged): boolean {
        if (models.StorageConfigurationBaseForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForSaasUserManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
